import { Component, OnInit, OnDestroy, AfterViewInit, ViewChild, ElementRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ContainerComponent } from '../../layout/container/container.component';
import { AnalyticsService } from '../../../services/analytics.service';

@Component({
  selector: 'app-phone-assistance-banner',
  standalone: true,
  imports: [CommonModule, ContainerComponent],
  templateUrl: './phone-assistance-banner.component.html',
  styleUrl: './phone-assistance-banner.component.scss'
})
export class PhoneAssistanceBannerComponent implements OnInit, OnDestroy, AfterViewInit {
  @ViewChild('sectionElement', { static: false }) sectionElement?: ElementRef;
  constructor(private analyticsService: AnalyticsService) {}

  ngOnInit() {
    // Track banner view when component loads
    setTimeout(() => this.trackBannerView(), 100);
  }

  ngAfterViewInit() {
    // Registrar la sección para tracking de analytics
    if (this.sectionElement?.nativeElement) {
      this.analyticsService.registerSectionForTracking(
        this.sectionElement.nativeElement,
        'Phone Assistance Banner',
        'phone-assistance-banner-section'
      );
    }
  }

  ngOnDestroy() {
    // Unregister section from analytics tracking
    if (this.sectionElement?.nativeElement) {
      this.analyticsService.unregisterSectionFromTracking(this.sectionElement.nativeElement);
    }
  }

  // Método para manejar el click en el banner
  onBannerClick(): void {
    console.log('🖱️ Phone Assistance Banner: Clic en banner');

    // Track banner click event
    this.trackBannerClick();
  }

  // Método para rastrear el click en el banner
  private trackBannerClick(): void {
    const eventData = this.analyticsService.createPromotionEventData(
      0, // ID del banner (0 para banner principal)
      this.getCurrentDeviceType(),
      'Phone Assistance Banner - Servicio al Cliente 600 390 9000',
      'assets/needHelp.png',
      'phone_assistance_banner'
    );

    this.analyticsService.trackPromotionSelection(eventData);
  }

  // Método para rastrear cuando se muestra el banner (view) - solo si es visible
  private trackBannerView(): void {
    if (!this.sectionElement?.nativeElement) return;

    const eventData = this.analyticsService.createPromotionEventData(
      0, // ID del banner (0 para banner principal)
      this.getCurrentDeviceType(),
      'Phone Assistance Banner - Servicio al Cliente 600 390 9000',
      'assets/needHelp.png',
      'phone_assistance_banner'
    );

    this.analyticsService.trackPromotionViewIfVisible(eventData, this.sectionElement.nativeElement);
  }

  // Método para detectar el tipo de dispositivo
  private getCurrentDeviceType(): 'xl' | 'desktop' | 'tablet' | 'movil' {
    const width = window.innerWidth;
    if (width >= 1200) return 'xl';
    if (width >= 1024) return 'desktop';
    if (width >= 768) return 'tablet';
    return 'movil';
  }
}
